"use client";

import { Lang } from "@/i18n-config";

import { ButtonGroup } from "ui/core/button-group";

import { getTimeFrameOptions } from "../data/time-frame";

type ChartLayoutType = "overview" | "financialReport" | "stockSentiment";

type ButtonGroupProps = {
  type: ChartLayoutType;
  lang: Lang;
  onButtonClick: (value: string) => void;
  activeId?: string;
};

export const ChartTimeFrameButtonGroup = ({
  lang,
  type,
  activeId,
  onButtonClick,
}: ButtonGroupProps) => {
  const options = getTimeFrameOptions({ lang })[type];

  return (
    <ButtonGroup
      className="min-w-[280px]"
      options={options}
      onButtonClick={onButtonClick}
      activeId={activeId}
    />
  );
};
